import assertString from './assertString.js';
import isLuhnNumber from './isLuhnNumber.js';

const cards = {
  amex: /^3[47][0-9]{13}$/,
  dinersclub: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
  discover: /^6(?:011|5[0-9][0-9])[0-9]{12,15}$/,
  jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
  mastercard:
    /^(?:5[1-5][0-9]{14}|(?:2221|222[2-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12})$/,
  unionpay: /^(?:62[0-9]{14,17}|81[0-9]{14,17})$/,
  visa: /^(?:4[0-9]{12})(?:[0-9]{3,6})?$/,
  troy: /^(?:9792[0-9]{12}|650082[0-9]{10})$/,
};

const allCards = Object.values(cards);

export default function isCreditCard(card, options = {}) {
  assertString(card);
  const { provider } = options;
  const sanitized = card.replace(/[- ]+/g, '');

  if (provider && provider.toLowerCase() in cards) {
    if (!cards[provider.toLowerCase()].test(sanitized)) return false;
  } else if (provider && !(provider.toLowerCase() in cards)) {
    throw new Error(`${provider} is not a valid credit card provider.`);
  } else if (!allCards.some((rx) => rx.test(sanitized))) {
    return false;
  }

  return isLuhnNumber(sanitized);
}
